import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import DateSelect from './fields/date';
import GenderField from './fields/gender';
import NameField from './fields/name';
import ReadingHeaderPrice from './reading-header-price';
import moment from 'moment';

class Component extends BaseComponent {
    componentWillMount() {
        this.props.init(this.props.upc);

        this.setState({
            submitting: false,
            dirty: false,
            profile_chooser: 'friend',
            fields: {
                birth_name: {
                    label: 'Birth Name',
                    info: 'This is where you enter your name as given to you at birth. Enter the name given to you at' +
                        ' birth.',
                    value: null,
                    error: null,
                },
                name: {
                    label: 'Current Name',
                    info: 'This is where you enter the name you currently use when introducing yourself, signing ' +
                        'papers, etc. If you are married and have changed your name, this would require you to enter ' +
                        'your new name. If you have multiple last names, or a hyphenated one, use it all.',
                    value: null,
                    error: null,
                },
                gender: {
                    value: 'female',
                    error: null,
                },
                birth_date: {
                    label: 'Birth Date',
                    direction: 'past',
                    month: null,
                    day: null,
                    year: null,
                    value: null,
                    error: null,
                },
                forecast_date: {
                    label: 'Start Report',
                    month_only: true,
                    direction: 'future',
                    month: null,
                    year: null,
                    value: null,
                    error: null,
                },
            },
        });
    }

    render() {
        return (
            <report-teeup>
                {this.renderForRadios()}
                <form class='report-teeup-form' onSubmit={this.submit}>
                    {this.renderFields()}
                    <p class='price'>
                        <ReadingHeaderPrice />
                    </p>
                    <div class='button-container'>
                        <button
                          class={`button ${this.state.submitting ? 'disabled' : ''}`}
                          onClick={this.submit}
                          disabled={this.state.submitting}
                        >
                            {this.state.submitting ? 'submitting…' : 'Get my report'}
                        </button>
                    </div>
                </form>
            </report-teeup>
        );
    }

    renderFields = () => {
        if (this.props.fields) {
            return this.props.fields.map(this.renderField);
        }

        return null;
    }

    renderField = (field) => {
        let FieldType = null;

        if (field.type == 'name') {
            FieldType = NameField;
        } else if (field.type == 'string' && field.name == 'gender') {
            FieldType = GenderField;
        } else if (field.type == 'date') {
            FieldType = DateSelect;
        }

        if (FieldType) {
            return (
                <FieldType
                  {...this.state.fields[field.name]}
                  name={field.name}
                  category={this.props.category}
                  reportInput={this.reportInput}
                  dirty={this.state.dirty}
                />
            );
        }

        return null;
    }

    renderForRadios = () => {
        if (this.props.default_profile) {
            return (
                <div class='radio-input profile_chooser'>
                    <fieldset>
                        <legend>Enter Your Information</legend>
                        <br />
                        <label>
                            For you
                            <input
                              checked={this.state.profile_chooser == 'self'}
                              type='radio'
                              onClick={this.populateForm}
                            />
                        </label>
                        <label>
                            For a friend
                            <input
                              checked={this.state.profile_chooser == 'friend'}
                              type='radio'
                              onClick={this.clearForm}
                            />
                        </label>
                    </fieldset>
                </div>
            );
        }

        return null;
    }

    populateForm = () => {
        const profile = this.props.default_profile;
        const state = this.state;

        state.profile_chooser = 'self';

        if (profile) {

            const birth_name = profile.birth_mname
                ? `${profile.birth_fname} ${profile.birth_mname} ${profile.birth_lname}`.trim()
                : `${profile.birth_fname} ${profile.birth_lname}`.trim();

            [
                state.fields.birth_name.value,
                state.fields.birth_name.error,
                state.fields.name.value,
                state.fields.name.error,
                state.fields.gender.value,
            ] = [
                birth_name,
                null,
                `${profile.cur_fname} ${profile.cur_lname}`.trim(),
                null,
                profile.sex,
            ];

            if (profile.birth_date) {
                const birth_date = moment(profile.birth_date);
                [
                    state.fields.birth_date.year,
                    state.fields.birth_date.month,
                    state.fields.birth_date.day,
                    state.fields.birth_date.value,
                    state.fields.birth_date.error,
                ] = [
                    birth_date.format('YYYY'),
                    birth_date.format('MM'),
                    birth_date.format('DD'),
                    birth_date.format('YYYY-MM-DD'),
                    null,
                ];
            }

        }

        this.setState(state);
    }

    clearForm = () => {
        const state = this.state;

        [
            state.profile_chooser,
            state.fields.gender.value,
            state.fields.birth_name.value,
            state.fields.name.value,
            state.fields.birth_date.month,
            state.fields.birth_date.day,
            state.fields.birth_date.year,
            state.fields.birth_date.value,
        ] = [
            'friend',
            'female',
            null,
            null,
            null,
            null,
            null,
            null,
        ];

        this.setState(state);
    }

    submit = (e) => {
        e.preventDefault();
        this.setState({ submitting: true });

        const state = this.state;
        let error = false;

        Object.keys(state.fields).forEach(name => {
            if (name == 'name' || name == 'birth_name') {
                const value = state.fields[name].value;
                if (value) {
                    const number_of_values = value.replace(/[^\s]+/g, '').length + 1;
                    let error = null;

                    if (number_of_values == 0) {
                        error = "This field can't be empty.";
                    } else if (number_of_values == 1) {
                        error = 'This field requires at least first and last names.';
                    } else if (number_of_values > 3) {
                        error = 'This field requires first and last name. Middle name is optional';
                    }

                    this.reportInput(name, value, error);
                }
            }

            if (! state.fields[name].value) {
                error = true;
                state.fields[name].error = 'This field is required';
            } else if (state.fields[name].error) {
                error = true;
            }
        });

        if (error) {
            [state.dirty, state.submitting] = [true, false];
            this.setState(state);
        } else {
            const payload = [
                {
                    name: 'birth_name',
                    value: this.state.fields.birth_name.value,
                },
                {
                    name: 'name',
                    value: this.state.fields.name.value,
                },
                {
                    name: 'gender',
                    value: this.state.fields.gender.value,
                },
                {
                    name: 'month',
                    value: this.state.fields.birth_date.month,
                },
                {
                    name: 'day',
                    value: this.state.fields.birth_date.day,
                },
                {
                    name: 'year',
                    value: this.state.fields.birth_date.year,
                },
                {
                    name: 'month',
                    value: this.state.fields.forecast_date.month,
                },
                {
                    name: 'year',
                    value: this.state.fields.forecast_date.year,
                },
            ];
            this.props.submit(payload);
        }

        return false;
    }

    reportInput = (name, value, error) => {
        const state = this.state;

        if (name == 'birth_date') {
            const birth_date = moment(value);

            [
                state.fields[name].month,
                state.fields[name].day,
                state.fields[name].year,
            ] = [
                birth_date.format('MM'),
                birth_date.format('DD'),
                birth_date.format('YYYY'),
            ];
        } else if (name == 'forecast_date') {
            const forecast_date = moment(value);

            [
                state.fields[name].month,
                state.fields[name].year,
            ] = [
                forecast_date.format('MM'),
                forecast_date.format('YYYY'),
            ];
        }

        [ state.fields[name].value, state.fields[name].error ] = [ value, error ];

        this.setState(state);
    }
}

const mapStateToProps = (state) => ({
    default_profile: state.user.profiles && state.user.profiles.length ? state.user.profiles[0] : null,
    fields: state.fields,
});

const mapDispatchToProps = (dispatch) => ({
    init: (upc) => dispatch({ type: 'forecast:init', payload: upc }),
    submit: (payload) => dispatch({ type: 'product:submit', payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/report-teeup.js